import { z } from 'zod';

const schema = z.object({
  VITE_SUPABASE_URL: z.string().url(),
  VITE_SUPABASE_ANON_KEY: z.string().min(1),
  VITE_API_INTERNAL_URL: z.string().url(),
});

export const env = schema.parse(import.meta.env);
